import axios from 'axios';
import { getErrorAlert } from '../redux/actions'
import store from "../redux/store";

const api = axios.create({
  baseURL: process.env.REACT_APP_HOST+'/'
})

api.interceptors.response.use(
  (res) => {
    return res;
  },
  async (err) => {
    const st = err.response.status ;
    if ((st === 400 || st === 401 || st === 403 || st === 404 || st === 429 ) && typeof err.response.data == 'string' && err.response.data.length > 0) {
      store.dispatch(getErrorAlert(err.response.data));
    } else if (st === 500){
      store.dispatch(getErrorAlert("Server error"));
    }
    return Promise.reject(err);
  }
);
export {api};
